import React from 'react';
import PropTypes from 'prop-types';
import { getImagem } from '../../utils/imagens';
import { regiaoPremiacaoPropType } from '../../types/premiacoes';

const PremiacoesPorRegiao = ({ regioes }) => (
  <div className="premiacoes-regioes">
    <h2>PREMIAÇÃO POR REGIÃO</h2>
    {regioes.map((regiao) => (
      <section className="premiacoes-regiao" key={regiao.nome}>
        <h3 className="premiacoes-regiao__title">{regiao.nome}</h3>
        <ol className="premiacoes-regiao__grid">
          {regiao.colocados.map((item) => {
            const fotoSrc = item.foto && getImagem(item.foto);
            return (
              <li className="premiacoes-regiao__card" key={item.posicao}>
                <span className="premiacoes-regiao__position">
                  {item.posicao}º lugar
                </span>
                {fotoSrc && (
                  <img
                    className="premiacoes-regiao__image"
                    src={fotoSrc}
                    alt={item.vencedor}
                  />
                )}
                <h4 className="premiacoes-regiao__winner">{item.vencedor}</h4>
              </li>
            );
          })}
        </ol>
      </section>
    ))}
  </div>
);

PremiacoesPorRegiao.propTypes = {
  regioes: PropTypes.arrayOf(regiaoPremiacaoPropType).isRequired
};

export default PremiacoesPorRegiao;
